<template>
    <v-card class="modal-search-purpose-of-uses">
      <div class="" ref="modalScrollArea">
        <div class="modal-content">
          <div class="">
            <div class="card-text">
              <div class="accordion-container">
                <div class="responsive-search-section px-2">
                  <div class="search-section">
                      <img :src="search" alt="search-img">
                      <input type="text" placeholder="エリア名を入力すると候補から選択できます" v-model="searchText" @input="handleInput">
                      <i class="fa-solid fa-xmark" :class="{ active: searchText }" @click="removeSearch()"></i>
                  </div>
                  <button @click="closeModal" type="button" class="btn-close_popup">
                    とじる
                  </button>
                </div>
                <div v-if="searchText">
                    <div class="suggest-search-data-section px-2" v-if="matchedChildren.length > 0">
                        <ul>
                            <li v-for="child in matchedChildren" :key="child.id"  @click.stop="selectChild(child.id)" class="cursor-pointer">
                                <img :src="selectedItems.includes(child.id) ? RightIconActive : RightIcon" alt="right-icon">
                                {{ child.name }}
                            </li>
                        </ul>
                    </div>
                    <div class="suggest-search-data-section px-2" v-else>
                        <ul>
                            <li>
                                候補が見つかりませんでした。
                            </li>
                        </ul>
                    </div>
                </div>
              </div>
              
            </div>
          </div>
         
        </div>
      </div>
    </v-card>
  </template>
  
  <script setup>
  /* eslint-disable */
  import { defineEmits, ref } from "vue";
  import search from "@/client/assets/images/new-search.svg";
  import RightIcon from "@/client/assets/images/right-icon.svg";
  import RightIconActive from "@/client/assets/images/right-icon-active.svg";
  import { orderBy } from "lodash";

    const hiraganaTable = {
        'あ': ['あ', 'い', 'う', 'え', 'お'],
        'か': ['か', 'き', 'く', 'け', 'こ', 'きゃ', 'きゅ', 'きょ', 'が', 'ぎ', 'ぐ', 'げ', 'ご','ぎゃ','ぎゅ','ぎょ'],
        'さ': ['さ', 'し', 'す', 'せ', 'そ', 'しゃ', 'しゅ', 'しょ', 'ざ', 'じ', 'ず', 'ぜ', 'ぞ','じゃ','じゅ','じょ'],
        'た': ['た', 'ち', 'つ', 'て', 'と', 'ちゃ', 'ちゅ', 'ちょ', 'だ', 'ぢ', 'づ', 'で', 'ど'],
        'な': ['な', 'に', 'ぬ', 'ね', 'の', 'にゃ', 'にゅ', 'にょ'],
        'は': ['は', 'ひ', 'ふ', 'へ', 'ほ', 'ひゃ', 'ひゅ', 'ひょ', 'ば', 'び', 'ぶ', 'べ', 'ぼ', 'ぱ', 'ぴ', 'ぷ', 'ぺ', 'ぽ','びゃ','びょ','びゅ','ぴゃ','ぴゅ','ぴょ'],
        'ま': ['ま', 'み', 'む', 'め', 'も', 'みゃ', 'みゅ', 'みょ'],
        'や': ['や', 'ゆ', 'よ'],
        'ら': ['ら', 'り', 'る', 'れ', 'ろ', 'りゃ', 'りゅ', 'りょ'],
        'わ': ['わ', 'を']
    };

    function convertKanjiToFirstChar(kanji) {
    let firstChar = '';
    if(kanji){
        for (const key in hiraganaTable) {
            if (hiraganaTable[key].includes(kanji.charAt(0))) {
                firstChar = key;
                break;
            }
        }
    }
    if(firstChar == ''){
        firstChar = 'その他'
    }else{
        firstChar+='行'
    }
    return firstChar;
    }

  // Emit event for closing modal
  const emit = defineEmits(["handleCloseSearchModal","selectAreaChild"]);
  const closeModal = () => {
    emit("handleCloseSearchModal");
  };
  
  const props = defineProps({
    allListArea: {
      type: Array,
      required: true,
    },
    selectedItems: {
        type: Array,
        required: true,
    }
  });
  const searchText = ref("");
  const matchedChildren = ref([]);
  
  const handleInput = () => {
    const value = searchText.value.trim();

    if (!value) {
        matchedChildren.value = [];
        return;
    }

    matchedChildren.value = [];

    props.allListArea.forEach((item) => {
        const children = Array.isArray(item.child)? item.child : item.child && typeof item.child === 'object' ? Object.values(item.child): [];
        children.forEach((childItem) => {
        if (childItem.name.includes(value)) {
            matchedChildren.value.push({
            id: childItem.id,
            name: childItem.name,
            name_reading: childItem.name_reading,
            });
        }
        });
    });

    const groups = {};
    for (const key in hiraganaTable) {
        let groupKey = key + '行';
        groups[groupKey] = {
        letter: groupKey,
        active: true,
        areas: []
        };
    }
    groups['その他'] = {
        letter: 'その他',
        active: true,
        areas: []
    };

    matchedChildren.value.forEach(item => {
        item.name_reading = item.name_reading || '';
        const firstChar = convertKanjiToFirstChar(item.name_reading);
        (groups[firstChar] || groups['その他']).areas.push(item);
    });

    matchedChildren.value = Object.values(groups).flatMap(group => orderBy(group.areas, 'name_reading'));
};
const removeSearch = () => {
    searchText.value = "";
    matchedChildren.value = [];
}

const selectChild = (childId) => {
  emit("selectAreaChild", childId);
};

  </script>
    <style>
        .modal-search-purpose-of-uses {
            width: 100% !important;
            height: 100% !important;
        }
        .area-search-modal .v-overlay__content {
            max-width: 100%;
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
        }
        .area-search-modal .v-overlay-container .v-dialog > .v-overlay__content {
            width: 100% !important;
            height: 100% !important;
        }
        @media (max-width: 767px) {
            .v-overlay-container .area-search-modal.v-dialog > .v-overlay__content {
                max-width: 100% !important;
                height: 100% !important;
                width: 100% !important;
                max-height: 100% !important;
            }
        }
        .v-dialog__content {
            padding: 0 !important;
        }
    </style>
  
  <style scoped lang="scss">
    
    .responsive-search-section{
      display: flex;
      align-items: center;
      gap: 15px;
      justify-content: space-between;
      position: sticky;
      z-index: 10;
      padding-top: 10px;
    }
    .responsive-search-section .search-section {
      background: #f6f6f6;
      border-radius: 100px;
      padding: 13px 16px;
      display: flex;
      align-items: center;
      gap: 5px;
      width: 100%;
      box-shadow: 0px 0.64px 1.28px 0px #00000033;

    }
    .responsive-search-section .search-section img{
      width: 16px;
      height: 16px;
      min-width: 16px;
    }
    .responsive-search-section .search-section input {
      border: unset;
      outline: unset;
      font-size: 14px;
      font-weight: 400;
      flex: 1;
      width: 100%;
      color: #000;
    }
    .responsive-search-section .search-section input::placeholder {
        font-size: 12px;
        font-weight: 400;
        color: #afafaf;
    }
    .responsive-search-section .search-section i {
      color: #b4b4b4;
      margin-left: 10px;
      opacity: 0;
      cursor: pointer;
    }
    .responsive-search-section .search-section i.active{
        opacity: 9;
    }
    .responsive-search-section button{
      color: #2B7ECA;
      font-size: 12px;
      font-weight: 400;
      min-width: 50px;
      width: 50px;
    }
    .suggest-search-data-section{
      overflow-y: auto;
      margin-top: 15px;
      max-height: calc(100vh - 70px);
    }
    .suggest-search-data-section ul{
      margin: 0px;
      padding: 0px;
    }
    .suggest-search-data-section ul li{
      list-style: none;
      padding: 0px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 0px;
      border-bottom: 1px solid #AFAFAF;
      color: #222222;
      font-size: 12px;
      font-weight: 400;
      color: #222222;
    }

    /* Global styles for iOS Safari only */
    @supports (-webkit-touch-callout: none) {
      @media screen and (max-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
        input,
        textarea,
        select {
          font-size: 16px !important; /* Prevent zoom on focus */
        }
      }
    }
    @media screen and (-webkit-min-device-pixel-ratio:0) { 
      select,
      textarea,
      input {
        font-size: 16px !important;
      }
    }

    @media (max-width:374px){
      .responsive-search-section .search-section{
        max-width: 230px;
        min-width: 120px;
      }
    }
  </style>
